import { createContext } from 'react';
import { Socket } from 'socket.io-client';

export const SocketContext = createContext<SocketContextValue>({
  socket: null
});

export type SocketContextValue = {
  socket: Socket | null;
};
